/** Shared staff-select change logic for the user forms (UserDetailsComponent
 * and UserWorkspaceComponent). Toggling the already-selected staff, or picking
 * the empty/`-1` option, clears the selection; otherwise it sets it. Marks the
 * form dirty either way. */
export type StaffOption = { id: string; name: string; value: string }

export function applyStaffSelectChange(
  option: StaffOption | undefined,
  selectedStaff: StaffOption | undefined,
  setSelectedStaff: (s: StaffOption | undefined) => void,
  setIsDirtyForm: (dirty: boolean) => void,
) {
  if (selectedStaff && option && selectedStaff.id === option.id) {
    setSelectedStaff(undefined)
  } else if (!option || option.id === `-1`) {
    setSelectedStaff(undefined)
  } else {
    setSelectedStaff(option)
  }
  setIsDirtyForm(true)
}
